import { createMountsRomanoFrameConfig } from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { DoorType } from "@/app/@types/shared";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createAnyDoorsMountsRomanoFrameConfig = (
    partition: Partition,
    doorType: DoorType,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);

    const qty = Math.round(totalWidth * totalHeight) || 0;

    const mountKey = `mnt-frame-sq-romano-${doorType}`;

    return createMountsRomanoFrameConfig(mountKey).qty(0).area(qty).build();
};

export const RomanoAnyDoorsConfigs = (
    partition: Partition,
    doorType: DoorType,
) => [createAnyDoorsMountsRomanoFrameConfig(partition, doorType)];
